import { useQuery } from '@tanstack/react-query';

import { getDevelopmentDetails } from 'src/api/developmentService';

import { queryRetry } from '../query-retry';

export const useGetDevelopmentDetails = (
    developmentSlug: string | null,
    academicYear: string | null
) =>
    useQuery({
        queryKey: ['development-details', developmentSlug, academicYear],

        queryFn: async () => {
            if (!developmentSlug || !academicYear) {
                throw new Error('Development slug and academic year are required');
            }

            const developmentDetails = await getDevelopmentDetails(developmentSlug, academicYear);

            if (!developmentDetails) {
                throw new Error(`Development "${developmentSlug}" is missing details`);
            }

            return developmentDetails;
        },

        enabled: Boolean(developmentSlug && academicYear),
        retry: queryRetry,
    });
